import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';

import Styles from './ConfigsListItem.styles';

const RealDeviceConfigsListItem = ({
  name,
  os,
  osName,
  osVersion,
  resolutionWidth,
  resolutionHeight,
  screenSize,
  title,
}) => (
  <div>
    <div className={classNames(Styles.text, Styles.url)}>{title}</div>
    <div className={Styles.text}>{name}</div>
    <div className={Styles.text}>{`${osName} ${osVersion}`}</div>
    <div className={Styles.text}>{`${resolutionWidth} x ${resolutionHeight} | ${screenSize}"`}</div>
    <div className={Styles.icon}>
      <PlatformIcon name={os} />
    </div>
  </div>
);

RealDeviceConfigsListItem.propTypes = {
  name: PropTypes.string.isRequired,
  os: PropTypes.string.isRequired,
  osName: PropTypes.string.isRequired,
  osVersion: PropTypes.string.isRequired,
  resolutionHeight: PropTypes.number.isRequired,
  resolutionWidth: PropTypes.number.isRequired,
  screenSize: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

export default RealDeviceConfigsListItem;
